module.exports = __webpack_public_path__ + "static/media/5.320286a8.jpg";